import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  margin-bottom: 25px;
`

const Table = styled.table`
  width: 100%;
  font-size: 14px;
  border-collapse: collapse;
`

const TableHeader = styled.thead``

const TableRow = styled.tr`
  &:not(:last-child) {
    border-bottom: 1px solid #ddd;
  }
`

const TH = styled.th`
  padding: 10px 25px;
`

const List = styled.ul`
  display: flex;
  flex-direction: row;
  padding: 0;
  list-style-type: none;
`

const ListItem = styled.li`
  margin-right: 20px;
  width: 250px;

  &:last-child {
    text-align: center;
  }
`

const ListHeader = styled(ListItem)`
  font-weight: bold;
`

export default (props) => {
    const { extra } = props
    const { singleTicket } = extra

    if(singleTicket) {
        return (
            <>
            <Wrapper>
            <List>
                <ListHeader>Kö detta ärende tillhör</ListHeader>
                <ListHeader>Placering</ListHeader>
              </List>
              <List>
                <ListItem>Könamn</ListItem>
                <ListItem>{1}</ListItem>
              </List>
            </Wrapper>
          </>
        )
    }

  return (
    <>
    <p style={{ marginBottom: "15px"} }>Köer du är placerad i</p>
    <Wrapper>
      <Table>
        <TableHeader>
          <TableRow>
            <TH>Kö</TH>
            <TH>Ärendenummer</TH>
            <TH>Placering</TH>
          </TableRow>
        </TableHeader>
      </Table>
    </Wrapper>
  </>
    
  );
};